import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const AGB = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cream-white via-soft-gray to-cream-white">
      {/* Header with Back Button */}
      <div className="bg-charcoal text-cream-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center text-warm-sage hover:text-soft-taupe transition-colors mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zurück zur Startseite
          </Link>
          <div className="flex items-center space-x-4">
            <div className="bg-warm-sage/20 p-3 rounded-lg">
              <FileText className="h-8 w-8 text-warm-sage" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-serif font-light">
                Allgemeine Geschäftsbedingungen (AGB)
              </h1>
              <p className="text-warm-gray font-light mt-1">
                AGB für Coaching- und Beratungsleistungen
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="prose prose-lg max-w-none">
            <p className="text-warm-gray italic mb-8">
              Stand: <strong className="text-warm-sage">[BITTE DATUM EINFÜGEN]</strong>
            </p>

            {/* 1 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                1. Geltungsbereich
              </h2>
              <p className="text-charcoal leading-relaxed">
                Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über Coaching- und
                Beratungsleistungen, die zwischen <strong className="text-warm-sage">Sanaa Ait Balla – Mind’UP</strong> (nachfolgend
                „Anbieterin“, „wir“) und Verbraucherinnen oder Unternehmerinnen (nachfolgend „Kundin“, „Sie“)
                geschlossen werden. Abweichende Bedingungen der Kundin finden keine Anwendung, es sei denn,
                wir stimmen ihrer Geltung ausdrücklich in Textform zu.
              </p>
            </section>

            {/* 2 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                2. Leistungen, Formate, Sprachen
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Wir erbringen professionelle Coaching- und Beratungsleistungen u. a. in den Bereichen
                persönliche Entwicklung, interkulturelles Coaching, Karriere-/Business-Coaching, Begleitung rund
                um Schwangerschaft, Geburt, Matreszenz & Postpartum (keine Therapie) sowie Change-Management
                und Übergänge (Leben/Beruf).
              </p>
              <p className="text-charcoal leading-relaxed mb-2">
                Formate: Einzelsessions, Programme, ggf. Intensiv-/Immersions-Formate; online (z. B. Zoom/Google
                Meet, ohne Aufzeichnung) und vor Ort nach Vereinbarung.
              </p>
              <p className="text-charcoal leading-relaxed">
                Arbeitssprachen: Französisch, Deutsch, Arabisch. Ein konkreter Erfolg wird – der Natur von
                Coaching entsprechend – nicht geschuldet.
              </p>
            </section>

            {/* 3 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                3. Vertragsschluss
              </h2>
              <p className="text-charcoal leading-relaxed">
                Ihre Anfrage erfolgt per E-Mail, telefonisch oder über das Kontaktformular. Wir übersenden Ihnen
                ein Angebot mit Leistungsumfang, Honorar, Format und Rahmenbedingungen. Der Vertrag kommt
                zustande, wenn Sie dieses Angebot innerhalb der genannten Frist in Textform annehmen. Wir
                behalten uns vor, Anfragen ohne Angabe von Gründen abzulehnen.
              </p>
            </section>

            {/* 4 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                4. Preise, Währungen, Fälligkeit, Zahlungen
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Preise werden grundsätzlich in Euro (EUR) ausgewiesen; bei Kundinnen mit Wohnsitz in Marokko kann
                – nach Absprache – in MAD abgerechnet werden. Richtwert Einzelsession (privat): ab 170 €. Das
                konkrete Honorar kann variieren in Abhängigkeit von Land/Region (Kaufkraftkontext), Anwendungsfeld
                (privat vs. Business/Unternehmen) und Format (Einzelsession, Programm, Immersion).
              </p>
              <p className="text-charcoal leading-relaxed">
                Zahlungen via Banküberweisung, PayPal, ggf. Kreditkarte (über Zahlungsdienstleister). Raten sind
                im Einzelfall schriftlich möglich. Das Honorar ist spätestens am Tag der Session fällig, Programme
                vor Beginn, sofern nichts anderes vereinbart ist. Rechnungen stellen wir elektronisch zu. Umsatzsteuer
                fällt an, sofern gesetzlich geschuldet (
                <strong className="text-warm-sage">[USt-ID einfügen oder „Kleinunternehmerregelung“]</strong>).
              </p>
            </section>

            {/* 5 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                5. Termine, Absage, Umbuchung (No-Show)
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-charcoal mb-4">
                <li><strong>Bis 48 Std.</strong> vor Termin: kostenfrei.</li>
                <li><strong>24 – 48 Std.</strong> vor Termin: 50 % des Honorars.</li>
                <li><strong>&lt; 24 Std. oder Nichterscheinen:</strong> 100 % des Honorars.</li>
              </ul>
              <p className="text-charcoal leading-relaxed mb-4">
                Die Kundin kann einen geringeren Schaden nachweisen. Sagt die Anbieterin aus wichtigem Grund
                (z. B. Krankheit, höhere Gewalt) ab, wird ein Ersatztermin angeboten; auf Wunsch erfolgt Erstattung.
              </p>
            </section>

            {/* 6 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                6. Mitwirkung, Gesundheit, Abgrenzung zur Therapie
              </h2>
              <p className="text-charcoal leading-relaxed">
                Coaching setzt aktive Mitwirkung voraus. Coaching ist keine medizinische oder psychotherapeutische
                Behandlung, Diagnosen stellen wir nicht. Bei gesundheitlichen/psychischen Beschwerden wenden Sie sich
                an ärztliche/therapeutische Fachstellen. Wir können Aufträge ablehnen oder beenden, wenn der
                Coaching-Rahmen nicht geeignet ist.
              </p>
            </section>

            {/* 7 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                7. Vertraulichkeit
              </h2>
              <p className="text-charcoal leading-relaxed">
                Wir wahren Vertraulichkeit über alle im Coaching erlangten Informationen und handeln im Einklang
                mit dem ICF-Ethikkodex. Eine Weitergabe an Dritte erfolgt nur bei gesetzlicher Pflicht oder mit Ihrer
                ausdrücklichen Einwilligung.
              </p>
            </section>

            {/* 8 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                8. Online-Durchführung, Tools, Datenschutz
              </h2>
              <p className="text-charcoal leading-relaxed">
                Online-Sessions (z. B. Zoom/Google Meet) werden <strong>nicht aufgezeichnet</strong>. Es gelten die
                Datenschutzhinweise auf unserer Website. Beim Einsatz externer Tools/Plattformen kann es zu
                Datenübermittlungen in Drittländer kommen; wir nutzen hierfür geeignete Garantien (z. B.
                EU-Standardvertragsklauseln).
              </p>
            </section>

            {/* 9 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                9. Urheber- und Nutzungsrechte
              </h2>
              <p className="text-charcoal leading-relaxed">
                An Unterlagen, Übungen, Konzepten und sonstigen Inhalten behalten wir die Urheberrechte. Nutzung
                ausschließlich für eigene Zwecke im vereinbarten Kontext. Vervielfältigung, Weitergabe, Veröffentlichung
                oder gewerbliche Nutzung nur mit unserer vorherigen schriftlichen Zustimmung.
              </p>
            </section>

            {/* 10 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                10. Widerrufsrecht für Verbraucherinnen (Fernabsatz)
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Verbraucherinnen steht bei Fernabsatzverträgen ein gesetzliches Widerrufsrecht zu. Verlangen Sie
                ausdrücklich, dass wir vor Ablauf der Widerrufsfrist mit der Leistung beginnen, und erbringen wir die
                Leistung vollständig innerhalb der Frist, erlischt Ihr Widerrufsrecht. Bei Teilleistungen schulden Sie
                Wertersatz. Die Widerrufsbelehrung samt Muster-Formular stellen wir gesondert bereit.
              </p>
            </section>

            {/* 11 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                11. Haftung
              </h2>
              <p className="text-charcoal leading-relaxed">
                Wir haften für Vorsatz und grobe Fahrlässigkeit. Bei leichter Fahrlässigkeit haften wir nur bei
                Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), begrenzt auf den vertragstypischen,
                vorhersehbaren Schaden. Unberührt bleiben Ansprüche wegen Verletzung von Leben, Körper, Gesundheit,
                aus Produkthaftung sowie übernommener Garantien.
              </p>
            </section>

            {/* 12 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                12. Höhere Gewalt
              </h2>
              <p className="text-charcoal leading-relaxed">
                Ereignisse außerhalb unseres Einflussbereichs (z. B. Strom-/Internetausfälle, Ausfall von
                Videodiensten, Naturereignisse) befreien uns für die Dauer und im Umfang der Störung von der
                Leistungspflicht. Termine werden zeitnah nachgeholt.
              </p>
            </section>

            {/* 13 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                13. Verbraucherstreitbeilegung / OS-Plattform
              </h2>
              <p className="text-charcoal leading-relaxed">
                Wir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen. OS-Plattform der EU-Kommission:
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noreferrer"
                  className="text-warm-sage underline ml-1"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
                .
              </p>
            </section>

            {/* 14 */}
            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                14. Anwendbares Recht, Gerichtsstand
              </h2>
              <p className="text-charcoal leading-relaxed">
                Es gilt das Recht der Bundesrepublik Deutschland (ohne UN-Kaufrecht). Gerichtsstand – soweit
                zulässig – ist der Sitz der Anbieterin:
                <strong className="text-warm-sage"> [BITTE ORT EINFÜGEN]</strong>. Zwingende Verbraucherschutzvorschriften
                des Wohnsitzstaates bleiben unberührt.
              </p>
            </section>

            {/* 15 */}
            <section>
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                15. Schlussbestimmungen
              </h2>
              <p className="text-charcoal leading-relaxed">
                Sollte eine Bestimmung dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen
                unberührt. Änderungen dieser AGB bleiben vorbehalten; die jeweils aktuelle Fassung ist auf der
                Website veröffentlicht.
              </p>
              <div className="bg-warm-sage/10 p-6 rounded-xl border border-warm-sage/20 mt-6">
                <p className="text-charcoal leading-relaxed">
                  <strong className="text-warm-sage">Kontakt:</strong><br />
                  <strong className="text-warm-sage">[BITTE E-MAIL EINFÜGEN]</strong> –{' '}
                  <strong className="text-warm-sage">[BITTE POSTANSCHRIFT EINFÜGEN]</strong>
                </p>
              </div>
            </section>
          </div>
        </div>

        {/* Back to Home Button */}
        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-flex items-center text-warm-sage hover:text-charcoal transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AGB;
